/*
 * Klaviyo Featured Reviews Carousel — productplaatje injecteren.
 * De review-kaart linkt al naar het product; dit script leest de handle
 * uit die link, haalt de afbeelding + titel op via /products/{handle}.js
 * en zet die bovenin de kaart. Klaviyo laadt de kaarten async, vandaar de
 * MutationObserver + polling.
 */
(function () {
  function decorate(link) {
    if (link.dataset.klImg) return;
    var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!match) return;
    link.dataset.klImg = '1';

    fetch('/products/' + match[1] + '.js')
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (product) {
        if (!product || !product.featured_image) return;
        var src = product.featured_image.split('?')[0] + '?width=160';

        var chip = document.createElement('div');
        chip.className = 'kl-prod';

        var img = document.createElement('img');
        img.loading = 'lazy';
        img.src = src;
        img.alt = '';

        var title = document.createElement('span');
        title.textContent = product.title;

        chip.appendChild(img);
        chip.appendChild(title);

        var review = link.querySelector('.kl_reviews__carousel__review') || link;
        review.prepend(chip);
      })
      .catch(function () {});
  }

  function run() {
    document.querySelectorAll('.kl_reviews__carousel__link').forEach(decorate);
  }

  var tries = 0;
  var timer = setInterval(function () {
    run();
    if (document.querySelector('.kl-prod') || ++tries > 40) clearInterval(timer);
  }, 500);

  if (window.MutationObserver) {
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
  }
})();
